import { useSelector } from "react-redux";
import Interaction, {
  InteractionType,
} from "../../../models/interactions/Interaction";
import { IPlaySubSequence } from "../../../models/interactions/PlaySubSequence";
import { selectSelectedElement } from "../../../app/slices/TrainingSlice";
import { ISequence } from "../../../models/interactions/Sequence";
import { useMemo } from "react";
import { ISubSequence } from "../../../models/interactions/SubSequence";
import NodeStringDropdown from "../components/NodeStringDropdown";
import useUpdateSequenceInteraction from "./UpdateSequenceInteraction.hook";

export default function PlaySubSequenceNodePreview(props: {
  nodeId: string;
  interaction: Interaction;
}) {
  const interaction = props.interaction as IPlaySubSequence;
  const sequence = useSelector(selectSelectedElement) as ISequence;
  const { updateInteraction } = useUpdateSequenceInteraction();
  // we need a list here of all sub sequences in the sequence
  const subSequences = useMemo(() => {
    return sequence.nodes
      .filter(
        (node) => node.data.interaction.type === InteractionType.SubSequence
      )
      .map((node) => (node.data.interaction as ISubSequence).sequenceName);
  }, [sequence]);

  const dropdown = (
    <NodeStringDropdown
      items={subSequences}
      label="Sub Sequence"
      selectedItem={interaction.nodeToPlay}
      onClick={(nodeToPlay) => {
        updateInteraction(props.nodeId, {
          ...interaction,
          nodeToPlay,
        } as IPlaySubSequence);
      }}
    />
  );

  return (
    <div className="w-full h-full flex flex-col gap-[12px]">{dropdown}</div>
  );
}
